import { useState } from 'react';

function usePagination(data, itemsPerPage) {
    const [currentPage, setCurrentPage] = useState(1);
    const [datosPrevios, setDatosPrevios] = useState(data);

    // Ajuste de estado durante el render (patrón oficial de React): al cambiar
    // la lista —otro color ANDON, o una recarga— se vuelve a la página 1. Sin
    // esto, pasar de un color con muchos tipos (página 3) a uno con pocos
    // dejaba la página 3 seleccionada y el modal se veía vacío.
    if (data !== datosPrevios) {
        setDatosPrevios(data);
        setCurrentPage(1);
    }

    const maxPage = Math.ceil(data.length / itemsPerPage);

    function currentData() {
        const begin = (currentPage - 1) * itemsPerPage;
        const end = begin + itemsPerPage;
        return data.slice(begin, end);
    }

    function next() {
        setCurrentPage((currentPage) => Math.min(currentPage + 1, Math.max(1, maxPage)));
    }

    function prev() {
        setCurrentPage((currentPage) => Math.max(currentPage - 1, 1));
    }

    function jump(page) {
        const pageNumber = Math.max(1, page);
        setCurrentPage((currentPage) => Math.min(pageNumber, Math.max(1, maxPage)));
    }

    return { next, prev, jump, currentData, currentPage, maxPage };
}

export default usePagination;
